var __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'underscore', 'underscore.string', 'backbone', 'mixin', 'core', 'app-common/component/inbox-events', 'app-common/component/loader', 'component/document-viewer', 'component/document-uploader', 'app-common/component/notification', 'app-common/component/api-call', 'common/component/money-formatter', 'common/component/date-formatter', 'app-common/component/combobox', 'app-common/view/toolbar', 'component/reconciliation/categorizer-view', 'component/reconciliation/ledger-storage', 'component/categorizer', 'app-common/component/notes', 'app-common/component/confirm-dialog', 'model/reconciliation', 'collection/ledger-account', 'collection/categorizer-rule', 'template/reconciliation/reconciliation-table.htm', 'template/reconciliation/landing.htm', 'template/reconciliation/uploader.htm', 'template/reconciliation/transaction-header.htm', 'common/location', 'common/lib/jquery.datatables', 'common/lib/date', 'app-common/lib/jquery.flexselect', 'app-common/lib/jquery.velocity'], function($, _, _s, Backbone, mixin, core, inboxEvents, loader, DocumentViewer, documentUploader, NotificationSupport, apiCall, moneyFormatter, dateFormatter, Combobox, ToolbarView, CategorizerView, LedgerStorage, Categorizer, NotesView, confirmDialog, ReconciliationModel, LedgerAccountCollection, CategorizerRuleCollection, reconciliationTableTemplate, landingTemplate, uploaderTemplate, transactionHeaderTemplate, locationConfig) {
  var ReconciliationView;
  return ReconciliationView = (function(_super) {

    __extends(ReconciliationView, _super);

    function ReconciliationView() {
      this.showInternalNotesView = __bind(this.showInternalNotesView, this);
      this.initializeLedgerAccountFlexSelect = __bind(this.initializeLedgerAccountFlexSelect, this);
      ReconciliationView.__super__.constructor.apply(this, arguments);
    }

    ReconciliationView.prototype.pageId = 'reconciliation';

    ReconciliationView.prototype.events = {
      'click .mark-processed-feature': 'markAsProcessed',
      'click .download-feature': 'downloadAsXls',
      'click .wip-feature': 'downloadWip',
      'click .reconcile-feature': 'startReconciliation',
      'click .categorizer-add-feature': 'toggleCategorizerAdd',
      'click .matched': 'toggleCategorizerEdit',
      'click .show-processed-feature': 'toggleProcessed',
      'click .prev-feature': 'prev',
      'click .next-feature': 'next',
      'keyup .search-field': 'search',
      'change .vendor input': function(e) {
        var element;
        element = $(e.currentTarget);
        return this.updateVendorName(this.getIdByElement(element), element.val());
      },
      'dropdownPicked .ledger-account input': function(e) {
        var $row, data, element, id, newData, rowEl, value;
        element = $(e.currentTarget).prev();
        $row = element.closest('.transaction-row');
        rowEl = _.first($row);
        id = this.getIdByElement(element);
        value = element.val();
        this.ledgerStorage.update(id, value);
        this.updateLedgerAccount(id, value);
        data = this.datatable.fnGetData(rowEl);
        newData = _.extend(data, {
          defaultLedgerId: value
        });
        this.datatable.fnUpdate(newData, rowEl, 3, false, false);
        return this.initializeSuggestedLedgerFlexSelect(rowEl);
      },
      'dropdownPicked .suggested-categories input': function(e) {
        var $reset, $row, $save, element, id, index, value;
        element = $(e.currentTarget).prev();
        id = this.getIdByElement(element);
        value = element.val();
        $row = element.closest('.suggested-categories__row');
        $reset = $(e.currentTarget).next();
        $save = $(e.currentTarget).next().next();
        index = $row.data('index');
        $reset.attr('data-ledger-id', value);
        $save.attr('data-ledger-id', value);
        $row.toggleClass('edited', value > 0);
        return this.updateSuggestedCategories(id, value, index);
      },
      'click .suggested-categories__reset': function(e) {
        var $reset, $row, $select, ledgerId, transactionId;
        $reset = $(e.currentTarget);
        $row = $reset.closest('.suggested-categories__row');
        $select = $row.find('input');
        transactionId = $reset.data('transaction-id');
        ledgerId = $reset.data('ledger-id');
        $select.val('');
        $row.removeClass('edited');
        return this.removeSuggestedCategories(transactionId, ledgerId);
      },
      'click .suggested-categories__save': function(e) {
        var $row, $save, data, element, id, newData, rowEl, value;
        $save = $(e.currentTarget);
        value = $save.data('ledger-id');
        element = $(e.currentTarget).prev().prev();
        $row = element.closest('.transaction-row');
        $row.addClass('edited');
        rowEl = _.first($row);
        id = this.getIdByElement(element);
        this.ledgerStorage.update(id, value);
        this.updateLedgerAccount(id, value);
        data = this.datatable.fnGetData(rowEl);
        newData = _.extend(data, {
          defaultLedgerId: value,
          suggestedLedgers: []
        });
        this.datatable.fnUpdate(newData, rowEl, void 0, false, false);
        return this.initializeLedgerAccountFlexSelect(rowEl);
      },
      'change td.confirm input': function(e) {
        var element;
        element = $(e.currentTarget);
        return this.updateConfirmation(this.getIdByElement(element), element.prop('checked'));
      },
      'change td.tax input': function(e) {
        var element;
        element = $(e.currentTarget);
        return this.updateSalesTax(this.getIdByElement(element), element.prop('checked'));
      }
    };

    ReconciliationView.prototype.accountStatementId = null;

    ReconciliationView.prototype.sourceLedgerAccountId = null;

    ReconciliationView.prototype.datatable = null;

    ReconciliationView.prototype.navigation = null;

    ReconciliationView.prototype.navigationEventMode = null;

    ReconciliationView.prototype.fileReconciliation = false;

    ReconciliationView.prototype.ledgerSelect = null;

    ReconciliationView.prototype.filterShowing = false;

    ReconciliationView.prototype.notFound = false;

    ReconciliationView.prototype.clientDataLoopTime = 60;

    ReconciliationView.prototype.awaitingCategoryLedgerIds = [];

    ReconciliationView.prototype.$container = function() {
      return $('.reconciliation__container');
    };

    ReconciliationView.prototype.$notesContainer = function() {
      return this.$('.internal-notes-view__container');
    };

    ReconciliationView.prototype.$transactionDetailsContainer = function() {
      return this.$('.transaction-details__container');
    };

    ReconciliationView.prototype.$row = function(id) {
      return this.$("#reconciliation_row_id_" + id);
    };

    ReconciliationView.prototype.initialize = function(options, params) {
      var init, promise,
        _this = this;
      options = _.extend(options, {
        features: ['wip', 'download', 'categorizer-add', 'reconcile', 'mark-processed', 'show-processed', 'search'],
        attachedFeatures: ['search']
      });
      ReconciliationView.__super__.initialize.call(this, options, params);
      this.clientId = core.getCurrentClientId();
      this.defaultLedgers = core.getDefaultLedgers();
      this.accountStatementId = (params != null ? params[0] : void 0) || null;
      this.navigationEventMode = (params != null ? params[1] : void 0) || null;
      this.ledgerStorage = new LedgerStorage(this.accountStatementId);
      this.categorizer = new Categorizer(this.clientId);
      this.categorizerView = new CategorizerView();
      this.listenTo(this.categorizerView, 'categorizer.rule.changed', this.reloadTable);
      this.listenTo(this.categorizerView, 'categorizer.view.hidden', this.handleCategorizerHidden);
      this.model = new ReconciliationModel({
        id: this.accountStatementId
      });
      init = function() {
        if (_this.accountStatementId && !options.noNavigation && _this.navigationEventMode === 'US') {
          _this.navigation = inboxEvents.getNavigation(_this.accountStatementId, 'unprocessed.statement');
        }
        return _this.render();
      };
      if (this.accountStatementId) {
        this.clientDataInterval = setInterval((function() {
          return apiCall('reconciliation', _this.accountStatementId + '/keepalive');
        }), this.clientDataLoopTime * 1000);
        loader.init();
        promise = this.model.fetch();
        promise.always(function() {
          return loader.hide();
        });
        promise.done(function() {
          return init();
        });
        promise.fail(function() {
          _this.notFound = true;
          return init();
        });
      } else {
        setTimeout(init, 50);
      }
      return this.on('sidebar:maximized', function() {
        return _this.hideCategorizerView();
      });
    };

    ReconciliationView.prototype.render = function() {
      var templateData;
      ReconciliationView.__super__.render.apply(this, arguments);
      templateData = {
        icon: 'ss-gizmo ss-calculator',
        clientCompany: core.getCurrentClient().get('company'),
        formattedFileName: this.model.get('fileName'),
        templateLink: locationConfig.apiRoot + core.getConfig().apiPrefix + 'reconciliation.json/client_template/' + core.getCurrentClientId(),
        totalBalance: this.calculateTotalBalance(),
        balancePreviews: this.model.get('balancePreviews'),
        moneyFormatter: moneyFormatter,
        note: this.model.get('note')
      };
      this.ledgerAccountsCollection = core.getCollection('ledgerAccounts');
      this.setAwaitingCategoryLedgerIds();
      if (this.accountStatementId) {
        this.prepareLedgerControl();
        this.$el.html(_.template(reconciliationTableTemplate, _.extend(templateData, this.model.toJSON())));
        this.$el.find('.report-header').removeClass('compact');
        this.initTable();
        this.initCategorizerView();
        this.showAllFeatures();
        this.setupKeyboardShortcuts();
        if (!_.isEmpty(this.navigation)) {
          this.initNavigation();
        }
        if (this.notFound) {
          return this.initNotFoundMode();
        }
      } else {
        this.$el.html(_.template(landingTemplate, templateData));
        this.initNotifications();
        return this.initUploader(['xls', 'xlsx', 'csv']);
      }
    };

    ReconciliationView.prototype.setAwaitingCategoryLedgerIds = function() {
      return this.awaitingCategoryLedgerIds = _.chain(core.getDefaultLedgers()).pick('pending.category.expense', 'pending.category.revenue').values().map(function(ledger) {
        return ledger.id;
      }).value();
    };

    ReconciliationView.prototype.remove = function() {
      $(window).off('keydown.reconciliation');
      return clearInterval(this.clientDataInterval);
    };

    ReconciliationView.prototype.calculateTotalBalance = function() {
      return _.reduce(this.model.get('transactions'), (function(total, transaction) {
        return total + transaction.amount;
      }), 0);
    };

    ReconciliationView.prototype.prepareLedgerControl = function() {
      var currentLedgerId, ledgerAccount, selectableLedgerAccounts,
        _this = this;
      currentLedgerId = this.model.get('ledgerId');
      ledgerAccount = this.ledgerAccountsCollection.get(currentLedgerId);
      selectableLedgerAccounts = ledgerAccount && ledgerAccount.attributes.categoryId === '9' ? this.ledgerAccountsCollection.filter(function(account) {
        return account.isEditable() && account.attributes.categoryId === '9';
      }) : this.ledgerAccountsCollection.filter(function(account) {
        return account.isEditable() && account.attributes.categoryId !== '9';
      });
      this.ledgerSelect = $('<select/>');
      selectableLedgerAccounts.forEach(function(ledger) {
        var option;
        option = $('<option/>').attr('value', ledger.get('id')).text(_s.trim(ledger.get('name')));
        return _this.ledgerSelect.append(option);
      });
      return this.ledgerSelect.append($('<option/>').attr('value', 0).text(''));
    };

    ReconciliationView.prototype.initNavigation = function() {
      this.showFeatures(['prev', 'next', 'navigation-stats']);
      return this.$el.find('.navigation-stats').html("" + this.navigation.currentPosition + " of " + this.navigation.total);
    };

    ReconciliationView.prototype.prev = function() {
      if (this.navigation.prevId) {
        return core.getRouter().loadPage('reconciliation', [this.navigation.prevId, this.navigationEventMode]);
      }
    };

    ReconciliationView.prototype.next = function() {
      if (this.navigation.nextId) {
        return core.getRouter().loadPage('reconciliation', [this.navigation.nextId, this.navigationEventMode]);
      }
    };

    ReconciliationView.prototype.initNotFoundMode = function() {
      this.$el.find('.feature:not(.navigation-item)').hide();
      this.$el.find('.not-found-area').show();
      if (!_.isEmpty(this.navigation)) {
        return this.$el.find('.not-found-area').addClass('has-navigation');
      }
    };

    ReconciliationView.prototype.setupKeyboardShortcuts = function() {
      var _this = this;
      return $(window).on('keydown.reconciliation', null, 'esc', function(e) {
        e.preventDefault();
        if (_this.categorizerView.isVisible()) {
          _this.hideCategorizerView();
        }
        return _this.hideInternalNotesView();
      });
    };

    ReconciliationView.prototype.initTable = function() {
      var _this = this;
      this.datatable = this.$el.find('.reconciliation-table').dataTable({
        aoColumnDefs: [
          {
            aTargets: [0],
            sTitle: 'Date <span class="ss-up"></span> <span class="ss-down"></span>',
            mData: 'dateOfTransaction',
            sClass: 'date',
            sWidth: '8%',
            bSortable: true,
            bSearchable: false,
            sType: 'string',
            mRender: function(dateOfTransaction, type) {
              var date;
              date = new Date(dateOfTransaction);
              if (type === 'sort') {
                return date.getTime().toString();
              } else {
                return ("<span class='month-day'>" + (date.toString('MMM')) + " " + (date.toString('dd')) + "</span><br />") + ("<span class='year'>" + (date.getFullYear()) + "</span>");
              }
            }
          }, {
            aTargets: [1],
            sTitle: 'Company <span class="ss-up"></span> <span class="ss-down"></span>',
            mData: 'vendorName',
            sClass: 'vendor edit-on',
            sWidth: '33%',
            bSortable: true,
            bSearchable: true,
            mRender: function(vendorName, type) {
              if (type === 'filter') {
                return vendorName;
              } else if (type === 'sort') {
                return vendorName;
              } else {
                return "<span>" + vendorName + "<span/>";
              }
            }
          }, {
            aTargets: [2],
            sTitle: 'Account',
            mData: 'defaultLedgerId',
            sClass: 'ledger-account ledger ledger-simple',
            sWidth: '22%',
            bSortable: false,
            bSearchable: true,
            mRender: function(defaultLedgerId, type, data) {
              var filteredLedgers, ledgerSelect, _ref, _ref1;
              filteredLedgers = _.filter(_this.ledgerAccountsCollection.toJSON(), function(ledger) {
                return ledger.categoryId !== '9';
              });
              if ((_ref = data.reconciliationState) === 'TRANSFER' || _ref === 'CONFLICT' || _ref === 'STILL_NO_RECEIPT' || _ref === 'MATCHED') {
                return ((_ref1 = _.findWhere(filteredLedgers, {
                  id: defaultLedgerId
                })) != null ? _ref1.name : void 0) || '';
              } else if (data.multiline) {
                return 'Multiline';
              } else {
                if (type === 'display') {
                  ledgerSelect = _this.ledgerSelect.clone();
                  ledgerSelect.attr('id', "ledger-" + data.id);
                  ledgerSelect.attr('data-default-value', defaultLedgerId);
                  return $('<div/>').append(ledgerSelect).html();
                } else {
                  return defaultLedgerId;
                }
              }
            }
          }, {
            aTargets: [3],
            sTitle: 'Suggested Categories',
            mData: null,
            sClass: 'suggested-categories ledger ledger-simple',
            sWidth: '22%',
            bSortable: false,
            bSearchable: false,
            mRender: function(defaultLedgerId, type, data) {
              var $label, $ledgerSelect, $reset, $row, $rows, $save, getLedgerId, index, rowCount, _i, _ref;
              if ((_ref = data.reconciliationState) === 'TRANSFER' || _ref === 'CONFLICT' || _ref === 'STILL_NO_RECEIPT' || _ref === 'MATCHED') {
                return '';
              }
              if (!_.contains(_this.awaitingCategoryLedgerIds, data != null ? data.defaultLedgerId : void 0)) {
                return '';
              }
              getLedgerId = function(index) {
                var _ref1, _ref2;
                return (data != null ? (_ref1 = data.suggestedLedgers) != null ? (_ref2 = _ref1[index]) != null ? _ref2.ledgerAccountId : void 0 : void 0 : void 0) || 0;
              };
              $label = function(index) {
                var _$label;
                _$label = $('<div/>').text("" + (index + 1));
                return _$label.attr('class', 'suggested-categories__label');
              };
              $ledgerSelect = function(index) {
                var _$ledgerSelect;
                _$ledgerSelect = _this.ledgerSelect.clone();
                _$ledgerSelect.attr('data-id', "ledger-" + data.id);
                return _$ledgerSelect.attr('data-default-value', getLedgerId(index));
              };
              $reset = function(index) {
                var _$reset;
                _$reset = $('<div class="suggested-categories__reset ss-gizmo ss-delete control"></div>');
                _$reset.attr('data-transaction-id', data.id);
                return _$reset.attr('data-ledger-id', getLedgerId(index));
              };
              $save = function(index) {
                var _$save;
                if (getLedgerId(index) > 0) {
                  _$save = $('<div class="suggested-categories__save ss-gizmo ss-check control"></div>');
                  _$save.attr('data-transaction-id', data.id);
                  return _$save.attr('data-ledger-id', getLedgerId(index));
                }
              };
              $row = function(index) {
                var _$row;
                _$row = $('<div/>').attr('class', 'suggested-categories__row');
                if (index > 0 && !getLedgerId(index - 1)) {
                  return false;
                }
                return _$row.append($label(index)).append($ledgerSelect(index)).append($reset(index)).append($save(index)).attr('data-index', index);
              };
              rowCount = 3;
              $rows = $('<div/>');
              for (index = _i = 0; 0 <= rowCount ? _i < rowCount : _i > rowCount; index = 0 <= rowCount ? ++_i : --_i) {
                $rows.append($row(index));
              }
              return $rows.html();
            }
          }, {
            aTargets: [4],
            sTitle: 'Document',
            mData: 'receiptId',
            sClass: 'document',
            sWidth: '10%',
            bSortable: false,
            bSearchable: false,
            mRender: function(receiptId) {
              if (receiptId) {
                return "<div data-id='" + receiptId + "' class='receipt-action backing-icon'><span class='ss-gizmo ss-file'></span></div>";
              } else {
                return '';
              }
            }
          }, {
            aTargets: [5],
            mData: null,
            sClass: 'actions',
            sWidth: '10%',
            bSortable: false,
            bSearchable: false,
            mRender: function(state, type, data) {
              var internalNotes, isFlagged, isUnflagged, output;
              internalNotes = data.internalNotes;
              output = '';
              if (!internalNotes.length) {
                return output;
              }
              isFlagged = _.some(internalNotes, function(note) {
                return note.flagged;
              });
              isUnflagged = _.some(internalNotes, function(note) {
                return !note.flagged;
              });
              if (isUnflagged) {
                output += '<div class="action-icon"><span class="ss-gizmo ss-users"></span></div>';
              }
              if (isFlagged) {
                output += '<div class="action-icon"><span class="ss-gizmo ss-flag"></span></div>';
              }
              return output;
            }
          }, {
            aTargets: [6],
            sTitle: 'Amount',
            mData: 'amount',
            sClass: 'amount',
            sWidth: '11%',
            bSortable: false,
            bSearchable: true,
            mRender: function(amount, type) {
              if (type === 'filter') {
                return amount;
              } else {
                return moneyFormatter.formatNumber(amount);
              }
            }
          }, {
            aTargets: [7],
            sTitle: 'Status',
            mData: 'reconciliationStateMessage',
            sClass: 'status',
            sWidth: '16%',
            bSortable: false,
            bSearchable: false,
            mRender: function(state, type, data) {
              var categorizationRuleId, matchedStatus;
              matchedStatus = data.categorizationRuleId ? ' matched' : '';
              categorizationRuleId = "data-rule-id='" + (data.categorizationRuleId || '') + "' data-default-ledger-id='" + (data.defaultLedgerId || '') + "'";
              return ("<div class='status-container" + matchedStatus + "' " + categorizationRuleId + ">") + "<div class='status-icon-wrapper pull-left'><div class='status-icon'></div></div>" + ("<div class='status-message pull-left'>" + state + "</div>") + "</div>";
            }
          }, {
            aTargets: [8],
            mData: null,
            bVisible: false,
            mRender: function(item, type, data) {
              if (data.reconciliationState === 'NO_RECEIPT') {
                return 10;
              } else if (data.reconciliationState === 'MATCHED_RULE' && data.reconciliationStateMessage.startsWith('ML suggestion')) {
                return 8;
              } else if (data.reconciliationState === 'MATCHED_RULE' && data.reconciliationStateMessage.startsWith('ML prediction')) {
                return 7;
              } else if (data.reconciliationState === 'MATCHED_RULE' && data.reconciliationStateMessage.startsWith('Global')) {
                return 6;
              } else if (data.reconciliationState === 'MATCHED_RULE' && data.reconciliationStateMessage.startsWith('Client')) {
                return 5;
              } else if (data.reconciliationState === 'MATCHED_RULE') {
                return 4;
              } else if (data.reconciliationState === 'CONFLICT') {
                return 3;
              } else {
                return 0;
              }
            }
          }, {
            aTargets: [9],
            mData: 'reconciliationState',
            bVisible: false
          }
        ],
        bInfo: true,
        bLengthChange: false,
        bFilter: true,
        bPaginate: true,
        iDisplayLength: 100,
        bAutoWidth: false,
        bSort: true,
        language: {
          emptyTable: 'This reconciliation contains no transactions. Select Post Transactions to update balances.'
        },
        sPaginationType: 'full_numbers',
        aaSortingFixed: [[8, 'desc']],
        fnRowCallback: function(row, data) {
          var input;
          $(row).attr('id', "reconciliation_row_id_" + data.id);
          if ($(row).hasClass('transaction-row')) {
            return row;
          }
          $(row).data('id', data.id).addClass('transaction-row');
          _this.initializeLedgerAccountFlexSelect(row);
          input = $(row).find("#ledger-" + data.id + "_flexselect");
          $(row).find("#ledger-" + data.id).change(function() {
            return input.addClass('edited');
          });
          _this.initializeSuggestedLedgerFlexSelect(row);
          switch (data.reconciliationState) {
            case 'CONFLICT':
              $(row).addClass('error-state');
              break;
            case 'NO_RECEIPT':
              $(row).addClass('warning-state');
              break;
            case 'MATCHED_RECEIPT':
            case 'TRANSFER':
              $(row).addClass('success-state');
              break;
            case 'MATCHED_RULE':
              $(row).addClass('categorized-state');
              break;
            default:
              $(row).addClass('normal-state');
          }
          return row;
        }
      });
      this.addTransactions();
      this.toggleProcessed();
      $(this.datatable).on('click', '.receipt-action', function() {
        return new DocumentViewer({
          document: $(this).data('id')
        });
      });
      return $(this.datatable).off().on('click', '.transaction-row', function(e, el) {
        var $el, transactionRowId, _ref;
        $el = $(e.target);
        transactionRowId = $el != null ? $el.attr('id') : void 0;
        if ($el != null ? (_ref = $el.attr('id')) != null ? _ref.includes('flexselect') : void 0 : void 0) {
          return false;
        }
        return _this.showInternalNotesView(e.target);
      });
    };

    ReconciliationView.prototype.initializeLedgerAccountFlexSelect = function(row) {
      var select;
      select = $(row).find('.ledger-account select');
      select.val(select.data('default-value'));
      return select.flexselect({
        sortAlphabetically: true
      });
    };

    ReconciliationView.prototype.initializeSuggestedLedgerFlexSelect = function(row) {
      var suggestedLedgerSelect;
      suggestedLedgerSelect = $(row).find('.suggested-categories select');
      suggestedLedgerSelect.each(function() {
        var $row, $select, defaultValue;
        $select = $(this);
        $row = $select.closest('.suggested-categories__row');
        defaultValue = $select.data('default-value');
        $select.val(defaultValue);
        return $row.toggleClass('edited', defaultValue > 0);
      });
      return this.suggestedFlexSelect = suggestedLedgerSelect.flexselect({
        sortAlphabetically: true
      });
    };

    ReconciliationView.prototype.getCategorizableTransactions = function(transactions) {
      var categorizableTransactions, groupedTransactions, nonCategorizableStates, nonCategorizableTransactions;
      nonCategorizableStates = ['MATCHED'];
      groupedTransactions = _.groupBy(transactions, 'reconciliationState');
      categorizableTransactions = _.flatten(_.omit(groupedTransactions, nonCategorizableStates));
      nonCategorizableTransactions = _.flatten(_.pick(groupedTransactions, nonCategorizableStates));
      return {
        'categorizable': categorizableTransactions,
        'nonCategorizable': nonCategorizableTransactions
      };
    };

    ReconciliationView.prototype.addTransactions = function() {
      var addToTable, categorizableTransactions, markTransactionRowLedgerAsEdited, notCategorizedTransactions, promise, sourceLedgerAccountId, transactions, transactionsToCategorize, updateTransactionsWithLedgers,
        _this = this;
      updateTransactionsWithLedgers = function(transactions, ledgers) {
        transactions.forEach(function(transaction) {
          if (ledgers[transaction.id] != null) {
            return transaction.defaultLedgerId = ledgers[transaction.id];
          }
        });
        return transactions;
      };
      addToTable = function(transactions) {
        var transaction, _i, _len;
        for (_i = 0, _len = transactions.length; _i < _len; _i++) {
          transaction = transactions[_i];
          _this.datatable.fnAddData(transaction, false);
        }
        return _this.datatable.fnDraw();
      };
      markTransactionRowLedgerAsEdited = function(ledgers) {
        var id, _i, _len, _ref, _results;
        _ref = _.keys(ledgers);
        _results = [];
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          id = _ref[_i];
          _results.push(_this.$el.find("#ledger-" + id + "_flexselect").addClass('edited'));
        }
        return _results;
      };
      this.model.resetToPreview();
      sourceLedgerAccountId = this.model.get('ledgerId');
      transactions = this.model.get('transactions');
      this.checkForDeleted(transactions);
      categorizableTransactions = this.getCategorizableTransactions(transactions);
      transactionsToCategorize = _.flatten(_.pick(categorizableTransactions, 'categorizable'));
      notCategorizedTransactions = _.flatten(_.pick(categorizableTransactions, 'nonCategorizable'));
      if (transactionsToCategorize.length > 0) {
        loader.init();
        promise = this.categorizer.categorize(transactionsToCategorize, sourceLedgerAccountId);
        promise.then(function(_arg) {
          var categorizedAndNotCategorizedTransactions, categorizedTransactions, categorizerRules, ledgers, updatedTransactions;
          categorizedTransactions = _arg[0], categorizerRules = _arg[1];
          ledgers = _this.ledgerStorage.load();
          categorizedAndNotCategorizedTransactions = categorizedTransactions.concat(notCategorizedTransactions);
          updatedTransactions = updateTransactionsWithLedgers(categorizedAndNotCategorizedTransactions, ledgers);
          _this.categorizerRuleCollection = new CategorizerRuleCollection(categorizerRules);
          _this.model.set('transactions', updatedTransactions);
          addToTable(updatedTransactions);
          return markTransactionRowLedgerAsEdited(ledgers);
        });
        promise.fail(function() {
          var ledgers, updatedTransactions;
          ledgers = _this.ledgerStorage.load();
          updatedTransactions = updateTransactionsWithLedgers(transactions, ledgers);
          _this.model.set('transactions', updatedTransactions);
          addToTable(updatedTransactions);
          return markTransactionRowLedgerAsEdited(ledgers);
        });
        return promise.always(function() {
          return loader.hide();
        });
      }
    };

    ReconciliationView.prototype.checkForDeleted = function(transactions) {
      var dateText, deleted, endDate, getDateString, numDeleted, startDate;
      getDateString = function(data) {
        var date;
        date = new Date(data.dateOfTransaction);
        return "" + (date.toString('MMM')) + " " + (date.toString('dd')) + ", " + (date.getFullYear());
      };
      deleted = _.filter(transactions, function(data) {
        return data.reconciliationState === 'CONFLICT';
      });
      if (deleted.length) {
        numDeleted = deleted.length;
        startDate = getDateString(_.first(deleted));
        endDate = getDateString(_.last(deleted));
        dateText = startDate === endDate ? "on " + startDate : "between " + startDate + " and " + endDate;
        return this.showNotification({
          text: "Posting this reconciliation file will remove " + numDeleted + " transactions " + dateText,
          type: 'warning'
        }, true);
      }
    };

    ReconciliationView.prototype.reloadTable = function() {
      this.datatable.fnClearTable();
      return this.addTransactions();
    };

    ReconciliationView.prototype.downloadAsXls = function() {
      return this.model.downloadAsXls();
    };

    ReconciliationView.prototype.downloadWip = function() {
      return this.makeAndDownloadWip();
    };

    ReconciliationView.prototype.makeAndDownloadWip = function() {
      var createFile, ledgerAccounts, transaction, values, _i, _len, _ref,
        _this = this;
      values = {};
      ledgerAccounts = core.getCollection('ledgerAccounts').toJSON();
      _ref = this.model.get('transactions');
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        transaction = _ref[_i];
        values[transaction.id] = {
          vendorName: transaction.vendorName
        };
        if (!transaction.multiline) {
          values[transaction.id].selectedLedger = transaction.defaultLedgerId;
        }
      }
      createFile = apiCall('reconciliation', "" + this.accountStatementId + "/wip", 'POST', JSON.stringify(values));
      loader.init();
      createFile.always(function() {
        return loader.hide();
      });
      return createFile.done(function(wip) {
        var fileId;
        fileId = wip.fileName;
        return location.href = locationConfig.apiRoot + core.getConfig().apiPrefix + ("reconciliation.json/" + _this.accountStatementId + "/wip/" + fileId);
      });
    };

    ReconciliationView.prototype.markAsProcessed = function() {
      var promise,
        _this = this;
      loader.init();
      promise = this.model.markAsProcessed();
      promise.fail(function() {
        return inboxEvents.updateAndRefreshEventCounters();
      });
      promise.done(function() {
        return _this.exit();
      });
      return promise.always(function() {
        return loader.hide();
      });
    };

    ReconciliationView.prototype.startReconciliation = function() {
      var promise,
        _this = this;
      loader.init();
      promise = this.model.startReconciliation();
      promise.fail(function(resp) {
        var defaultText, message, responseObj, _ref, _ref1;
        inboxEvents.updateAndRefreshEventCounters();
        responseObj = JSON.parse(resp.responseText);
        defaultText = "An error occurred on the server but no messages were given.\n" + "The full response was:\n\n";
        message = (responseObj != null ? (_ref = responseObj.messages) != null ? (_ref1 = _ref[0]) != null ? _ref1.message : void 0 : void 0 : void 0) || defaultText + resp.responseText;
        return confirmDialog.init(message, {
          cancel: "OK"
        });
      });
      promise.done(function() {
        return _this.exit();
      });
      return promise.always(function() {
        return loader.hide();
      });
    };

    ReconciliationView.prototype.toggleProcessed = function() {
      if (this.filterShowing) {
        this.datatable.fnFilter('', 9);
        return this.filterShowing = false;
      } else {
        this.datatable.fnFilter('^NO_RECEIPT|CONFLICT|MATCHED_RECEIPT|TRANSFER|MATCHED_RULE$', 9, true);
        return this.filterShowing = true;
      }
    };

    ReconciliationView.prototype.exit = function() {
      var promise,
        _this = this;
      promise = inboxEvents.updateAndRefreshEventCounters();
      return promise.always(function() {
        var _ref;
        _this.hideCategorizerView();
        _this.ledgerStorage.remove();
        _this.model.destroyInternalNotesCache();
        if (((_ref = _this.navigation) != null ? _ref.nextId : void 0) != null) {
          return core.getRouter().loadPage('reconciliation', [_this.navigation.nextId, _this.navigationEventMode]);
        } else {
          return window.history.back();
        }
      });
    };

    ReconciliationView.prototype.search = function(e) {
      return this.datatable.fnFilter($(e.currentTarget).val());
    };

    ReconciliationView.prototype.getIdByElement = function(element) {
      return $(element).closest('.transaction-row').data('id');
    };

    ReconciliationView.prototype.updateVendorName = function(id, value) {
      return this.updateTransaction(id, 'vendorName', value);
    };

    ReconciliationView.prototype.updateLedgerAccount = function(id, value) {
      this.updateTransaction(id, 'defaultLedgerId', value);
      return this.removeCategorizationMetadata(id);
    };

    ReconciliationView.prototype.getSuggestedCategories = function(transactionId) {
      var _ref;
      return ((_ref = this.model.getTransaction(transactionId)) != null ? _ref.suggestedLedgers : void 0) || [];
    };

    ReconciliationView.prototype.updateSuggestedCategories = function(id, suggestedLedgerId, index) {
      var hasSuggestedCategory, suggestedCategories, suggestedCategory;
      suggestedCategories = this.getSuggestedCategories(id);
      hasSuggestedCategory = _.findWhere(suggestedCategories, {
        ledgerAccountId: suggestedLedgerId
      });
      if (hasSuggestedCategory || (suggestedLedgerId === '0')) {
        return;
      }
      suggestedCategory = {
        ledgerAccountId: suggestedLedgerId
      };
      if (index > -1) {
        suggestedCategories[index] = suggestedCategory;
      } else {
        suggestedCategories.push(suggestedCategory);
      }
      this.model.saveSuggestedCategoriesCache(id, suggestedCategories);
      this.updateTransaction(id, 'suggestedLedgers', suggestedCategories);
      this.removeCategorizationMetadata(id);
      return this.updatesuggestedCategoriesIndicators(id, suggestedCategories, index);
    };

    ReconciliationView.prototype.removeSuggestedCategories = function(id, suggestedLedgerId) {
      var suggestedCategories;
      suggestedCategories = this.getSuggestedCategories(id);
      suggestedCategories = suggestedCategories.filter(function(item) {
        return item.ledgerAccountId !== (suggestedLedgerId != null ? suggestedLedgerId.toString() : void 0);
      });
      this.model.saveSuggestedCategoriesCache(id, suggestedCategories);
      this.updateTransaction(id, 'suggestedLedgers', suggestedCategories);
      return this.updatesuggestedCategoriesIndicators(id, suggestedCategories);
    };

    ReconciliationView.prototype.removeCategorizationMetadata = function(id) {
      var transaction, transactions;
      transactions = this.model.get('transactions');
      transaction = _.findWhere(transactions, {
        id: id
      });
      delete transaction.categorizationRuleId;
      delete transaction.categorizerLedgerId;
      delete transaction.categorizerMethod;
      return this.model.set('transactions', transactions);
    };

    ReconciliationView.prototype.updateSalesTax = function(id, value) {
      return this.updateTransaction(id, 'applySalesTax', value);
    };

    ReconciliationView.prototype.updateInternalNotes = function(id, value) {
      this.updateInternalNotesIndicators(id, value);
      this.model.saveInternalNotesCache(id, value);
      return this.updateTransaction(id, 'internalNotes', value);
    };

    ReconciliationView.prototype.updateTransaction = function(id, field, value) {
      var transaction, transactions;
      transactions = this.model.get('transactions');
      transaction = _.findWhere(transactions, {
        id: id
      });
      transaction[field] = value;
      return this.model.set('transactions', transactions);
    };

    ReconciliationView.prototype.updatesuggestedCategoriesIndicators = function(id, suggestedLedgers, index) {
      var $nextRow, data, newData, rowEl, _base, _base1, _base2, _base3, _base4, _ref, _ref1;
      rowEl = _.first(this.$row(id));
      data = this.datatable.fnGetData(rowEl);
      newData = _.extend(data, {
        suggestedLedgers: suggestedLedgers
      });
      this.datatable.fnUpdate(newData, rowEl, 3, false, false);
      this.initializeSuggestedLedgerFlexSelect(rowEl);
      if ((0 <= index && index <= 1)) {
        $nextRow = typeof (_base = $(rowEl)).find === "function" ? (_ref = _base.find('.suggested-categories__row')) != null ? _ref.last() : void 0 : void 0;
        return typeof $nextRow.find === "function" ? typeof (_base1 = $nextRow.find('input:text')).focus === "function" ? _base1.focus() : void 0 : void 0;
      } else if (index === 2) {
        $nextRow = typeof (_base2 = $(rowEl)).next === "function" ? typeof (_base3 = _base2.next()).find === "function" ? (_ref1 = _base3.find('.ledger-account')) != null ? _ref1.first() : void 0 : void 0 : void 0;
        return typeof $nextRow.find === "function" ? typeof (_base4 = $nextRow.find('input:text')).focus === "function" ? _base4.focus() : void 0 : void 0;
      }
    };

    ReconciliationView.prototype.updateInternalNotesIndicators = function(id, internalNotes) {
      var data, newData, rowEl;
      rowEl = _.first(this.$row(id));
      data = this.datatable.fnGetData(rowEl);
      newData = _.extend(data, {
        internalNotes: internalNotes
      });
      return this.datatable.fnUpdate(newData, rowEl, 5, false, false);
    };

    ReconciliationView.prototype.showInternalNotesView = function(e) {
      var id, transaction, transactions, _ref, _ref1,
        _this = this;
      if (this.categorizerView.isVisible()) {
        return;
      }
      id = this.getIdByElement(e);
      transactions = this.model.get('transactions');
      transaction = _.findWhere(transactions, {
        id: id
      });
      $('.transaction-row').removeClass('transactions-list__row--active');
      this.$row(id).addClass('transactions-list__row--active');
      if ((_ref = this.$notesContainer()) != null) {
        _ref.append('<div class="bl-notes-container"></div>');
      }
      if ((_ref1 = this.notesView) != null) {
        _ref1.remove();
      }
      this.notesView = new NotesView({
        $container: this.$('.bl-notes-container'),
        internalNotes: transaction['internalNotes'],
        syncNotes: function(notes) {
          return _this.updateInternalNotes(id, notes);
        }
      });
      this.renderTransactionHeader(transaction);
      this.$notesContainer().velocity('stop').velocity('transition.slideRightIn', {
        duration: 500,
        queue: false
      });
      this.expandContainer();
      return this.minimizeSidebar();
    };

    ReconciliationView.prototype.renderTransactionHeader = function(transaction) {
      var amount, dateOfTransaction, _ref, _transaction,
        _this = this;
      _transaction = _.clone(transaction);
      dateOfTransaction = _transaction.dateOfTransaction, amount = _transaction.amount;
      _.extend(_transaction, {
        date: dateFormatter.format(dateOfTransaction, {
          shortMonth: true
        }),
        amount: moneyFormatter.formatNumber(amount)
      });
      if ((_ref = this.$transactionDetailsContainer()) != null) {
        _ref.html(_.template(transactionHeaderTemplate, _transaction));
      }
      return this.$('.transaction-view__header__close-btn').off().on('click', function() {
        return _this.hideInternalNotesView();
      });
    };

    ReconciliationView.prototype.hideInternalNotesView = function() {
      var _ref;
      if ((_ref = this.notesView) != null) {
        _ref.remove();
      }
      this.$notesContainer().velocity('stop').velocity('transition.slideRightOut', {
        duration: 100,
        queue: false
      });
      $('.transaction-row').removeClass('transactions-list__row--active');
      this.condenseContainer();
      return this.maximizeSidebar();
    };

    ReconciliationView.prototype.initCategorizerView = function() {
      this.$el.find('.categorizer-view__container').html(this.categorizerView.$el);
      return this.hideCategorizerView();
    };

    ReconciliationView.prototype.toggleCategorizerAdd = function() {
      if (this.categorizerView.isVisible() && this.categorizerView.isDisplayingNewRule()) {
        return this.hideCategorizerView();
      } else {
        return this.showCategorizerView();
      }
    };

    ReconciliationView.prototype.toggleCategorizerEdit = function(e) {
      var id, rule;
      id = $(e.currentTarget).data('rule-id');
      if (!id) {
        return this.hideCategorizerView();
      } else if (this.categorizerView.isVisible() && this.categorizerView.isDisplayingRule(id)) {
        return this.hideCategorizerView();
      } else {
        rule = this.categorizerRuleCollection.find(function(rule) {
          return rule.get('id') === id;
        });
        return this.showCategorizerView(rule);
      }
    };

    ReconciliationView.prototype.showCategorizerView = function(categorizerRule) {
      this.hideInternalNotesView();
      this.expandContainer();
      this.categorizerView.show(categorizerRule);
      return this.minimizeSidebar();
    };

    ReconciliationView.prototype.hideCategorizerView = function() {
      return this.categorizerView.hide();
    };

    ReconciliationView.prototype.handleCategorizerHidden = function() {
      this.condenseContainer();
      return this.maximizeSidebar();
    };

    ReconciliationView.prototype.expandContainer = function() {
      return this.$container().velocity('stop').velocity({
        'margin-right': '350px'
      }, 200);
    };

    ReconciliationView.prototype.condenseContainer = function() {
      return this.$container().velocity('stop').velocity({
        'margin-right': '0px'
      }, 200);
    };

    ReconciliationView.prototype.initNotifications = function() {
      return this.setNotifications({
        can_not_upload: {
          type: 'error',
          text: "File is empty or it's in an invalid format. If you can't get the darn thing to work,\nleave your accountant a message and we'll get to it in a jiffy!"
        }
      });
    };

    ReconciliationView.prototype.initUploader = function(extensions) {
      var ledgers, ledgersCombobox, template,
        _this = this;
      ledgers = _.filter(core.getCollection('ledgerAccounts').toJSON(), function(ledger) {
        return ledger.role != null;
      });
      ledgersCombobox = new Combobox('ledger_account', 'ledger_account', 'editable', ledgers, null, {
        name: 'name',
        value: 'id'
      });
      template = _.template(uploaderTemplate, {
        ledgers: ledgers,
        ledgersCombobox: ledgersCombobox.show()
      });
      return documentUploader.initUploader({
        extensions: extensions,
        template: template,
        params: {
          uploadContext: 'reconciliation',
          clientId: this.clientId
        },
        container: $('.upload-wrapper')[0],
        onSubmit: function() {
          return loader.init();
        },
        onComplete: function(id, fileName, responseJSON) {
          var reconciliationResult;
          reconciliationResult = apiCall('reconciliation', $('#ledger_account').val() + '/' + responseJSON.result, 'POST');
          reconciliationResult.always(function() {
            return loader.hide();
          });
          reconciliationResult.fail(function(response) {
            var errorText;
            try {
              errorText = JSON.parse(response.responseText).messages[0].message;
              return _this.showNotification({
                text: errorText,
                type: 'error'
              }, true);
            } catch (e) {
              return _this.showNotification('can_not_upload');
            }
          });
          return reconciliationResult.done(function(id) {
            inboxEvents.updateAndRefreshEventCounters();
            return core.getRouter().loadPage('reconciliation', [id], {
              noNavigation: true
            });
          });
        }
      });
    };

    return ReconciliationView;

  })(mixin.of(ToolbarView, NotificationSupport));
});
